import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { compose } from 'redux';
import cn from 'classnames';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import ButtonComponent from '../../../containers/App/Components/Button/Button';
import LoadingField from '../../../containers/App/Components/LoadingField/LoadingField';
import { TransportOrderCreateModal } from './createTransportOrder';
import { HBox } from '../../../components/Box';
import { makeSelectLocale } from '../../../containers/LanguageProvider/selectors';
import { translateCountry } from '../../Companies/translate-countries';
import { TransportOrderFilter } from './TransportOrderFilter';
import { TransportOrderSearchText } from './SearchText';
import { FiltersCloud } from './FiltersCloud';

import styles from './Search.module.css';
import { COLOR_BG_LIGHT } from '../../../vars';
import { applyTransportOrderFilters, applyTransportOrderSeparateListFilters, resetTransportOrderFilter } from '../actions';
import { fetchTransporters } from '../../Transporters/actions';
import { selectTransporters } from '../../Transporters/selectors';
import { selectCountries } from '../../Companies/selectors';
import { selectWorks } from '../../Api/selectors';
import { selectTransportOrderFilter } from '../selectors';
import { REQUEST_TRANSPORTERS } from '../../Transporters/constants';
import { TransportOrderQuickFilter } from './TransportOrderQuickFilter';
import { TRANSPORT_ORDER_STATUS_OPTIONS } from '../constants';
import { TransportOrderSortSelector } from './TransportOrderSortSelector';

const Container = styled.div`
  & * .Dropdown-root {
    width: 100%;
  }

  .filters-rows {
    gap: 12px;
    padding: 0px 24px 24px 24px;
    background-color: white;
    @media (max-width: 768px) {
      max-width: 100%;
      padding: 15px;
    }
  }

  .form-controlField {
    margin-bottom: 0;
  }

  .button {
    width: auto;
  }

  .fw-light {
    font-size: 12px !important;
    font-weight: 400 !important;
    font-family: Poppins, sans-serif !important;
    padding-left: 10px !important;
    color: #808080 !important;
  }
  @media (max-width: 767.98px) {
    .fw-light {
      font-size: 16px !important;
    }
  }

  .button-filter-right {
    margin-top: -10px;
    margin-right: 10px;
  }

  .all-filters-block {
    padding: 10px;
    background-color: ${COLOR_BG_LIGHT};
  }

  .button-filter {
    padding-right: ${props => props.width > 500 && '24px'};
    & * .button {
      margin: 0px;
      margin-left: 12px;
      background-color: white;
      color: #808c9c;
      border-radius: 8px 8px 0px 0px;
      box-shadow: 0 -2px 6px -1px #ececef;
      &:hover {
        background-color: #0183d5;
        color: #fff;
        box-shadow: none;
      }
    }
  }

  .red-text {
    backgrond-color: red;
  }

  .row-1 {
    & * .decorated {
      width: 100%;
    }
  }

  .grid-column {
  }

  .grid-row-long {
    flex-basis: ${props => (props.width <= 1520 ? '100%' : '49%')};
  }
  .grid-row-short {
    border: 1px solid #cccccc;
    border-radius: 3px;
    flex-basis: 49%;
    & > .button {
      margin: 0px;
    }
  }

  .tablet-row {
    margin-bottom: 22px;
  }

  .row {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }

  .button-block {
    & * .button {
      margin: 0px;
    }
  }
  .input-element {
    font-size: 13px;
    height: 45px;
  }
`;

const STATE = {
  showAllFilters: false,
  filterToReset: null,
};
/* eslint-disable react/prefer-stateless-function */
class TransportOrderSearchComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    this.props.fetchTransporters();
  }

  get optionsCompanyType() {
    return ['company', 'individual'];
  }

  get optionsStatus() {
    return TRANSPORT_ORDER_STATUS_OPTIONS;
  }

  get statuses() {
    let statuses = _.times(6, n => {
      return this.lblStr(`transport_order.property.status.${n}`);
    })?.map(s => `${s}`);

    return statuses;
  }

  get optionsCompanyFrom() {
    return ['nl', 'eu', 'outside_eu'];
  }

  get optionsType() {
    return ['incoming', 'outgoing', 'other'];
  }

  get transporters() {
    const options = this.props.transporters?.map(t => {
      return {
        value: t?.id,
        label: `${t?.name ?? ''} ${t?.surname ?? ''}`.trim(),
      };
    });

    return options?.sort((a, b) => a.label.localeCompare(b.label));
  }

  get optionsCountryId() {
    let allowedCountries = [
      'Netherlands',
      'Germany',
      'France',
      'Belgium',
      'Luxemburg',
      'Austria',
      'Bulgaria',
      'Denmark',
      'Finland',
      'Italy',
      'Norway',
      'Poland',
      'Slovakia',
      'Slovenia',
      'Spain',
      'Switzerland',
      'Sweden',
      'Norway',
      'Czechia',
      'Hungary',
      'Portugal',
    ];

    let options = this.props.countries
      .filter(c => allowedCountries.includes(c.name))
      .map(c => ({ value: c.id, label: translateCountry(c.name, this.locale) }));
    return options;
  }

  get optionsOutgoingInvoiceFinalized() {
    return [
      { value: '1', label: this.lblStr('transport_order.filter.finalized') },
      { value: '0', label: this.lblStr('transport_order.filter.notFinalized') },
    ];
  }

  get optionsIndividual() {
    return [
      { value: '1', label: this.lblStr('yes') },
      { value: null, label: this.lblStr('no') },
    ];
  }

  get locale() {
    return this.props.locale;
  }

  toggleFiltersView = () => {
    this.setState(state => ({ showAllFilters: !state.showAllFilters }));
  };

  resetFilter = name => {
    this.setState({ filterToReset: name });
  };

  render() {
    if (!this.props.filter) return null;
    const STATUSES = this.statuses;

    return (
      <Container>
        <HBox right className="mt-2">
          {!this.props.overview && <TransportOrderCreateModal from_location={'new_transport'} />}
        </HBox>
        <div
          className={cn('container-fluid  p-0 mb-3', {
            [styles.mainWrapper]: window.innerWidth <= 768 || this.props.overview,
          })}
        >
          <>
            <TransportOrderQuickFilter separateFilter={this.props.separatePage} overview={this.props.overview} />
            {/* <TransportOrderQuickFilter /> */}
          </>

          {(window.innerWidth <= 768 || this.props.overview) && <></>}
          <div className="container-fluid p-3 bg-white">
            <div className="row justify-content-start" style={{ width: 'auto' }}>
              <div className="col-12 mb-3 col-sm-6 col-md-12 mb-3 col-lg-6 mb-3 col-xl-6 mb-3">
                <TransportOrderSearchText filter={this.props.filter} overviewPage separateFilter={this.props.separatePage} />
              </div>
              <div className="col-12 mb-3 col-sm-6 col-md-12 mb-3 col-lg-6 mb-3 col-xl-6 mb-3">
                <TransportOrderFilter
                  controlWidth={'100%'}
                  name="status"
                  type="single"
                  options={this.optionsStatus}
                  separateFilter={this.props.separatePage}
                />
              </div>
              <div className="col-12 mb-3 col-sm-6 col-md-12 mb-3 col-lg-6 mb-3 col-xl-6 mb-3">
                <TransportOrderFilter
                  controlWidth={'100%'}
                  name="type"
                  type="single"
                  options={this.optionsType}
                  separateFilter={this.props.separatePage}
                />
              </div>

              {window.innerWidth >= 1024 && (
                <>
                  <div className="col-12 mb-3 col-sm-6 col-md-12 mb-3 col-lg-6 mb-3 col-xl-6 mb-3">
                    <TransportOrderFilter
                      controlWidth={'100%'}
                      name="countryFrom"
                      type="multiple"
                      options={this.optionsCountryId}
                      noModify
                      separateFilter={this.props.separatePage}
                    />
                  </div>

                  <div className="col-12 mb-3 col-sm-6 col-md-12 mb-3 col-lg-6 mb-3 col-xl-6 mb-3">
                    <TransportOrderFilter
                      controlWidth={'100%'}
                      name="countryTo"
                      type="multiple"
                      options={this.optionsCountryId}
                      noModify
                      separateFilter={this.props.separatePage}
                    />
                  </div>

                  <div className="col-12 mb-3 col-sm-6 col-md-12 mb-3 col-lg-6 mb-3 col-xl-6 mb-3">
                    <TransportOrderFilter
                      controlWidth="100%"
                      name="outgoing_invoice_finalized"
                      type="multiple"
                      options={this.optionsOutgoingInvoiceFinalized}
                      noModify
                      separateFilter={this.props.separatePage}
                    />
                  </div>
                </>
              )}
              <div className="col-12 mb-3 col-sm-6 col-md-12 mb-3 col-lg-6 mb-3 col-xl-6 mb-3">
                {this.props.workTransporters ? (
                  <LoadingField />
                ) : (
                  <TransportOrderFilter
                    controlWidth={'100%'}
                    name="transporterId"
                    type="single"
                    options={this.transporters}
                    separateFilter={this.props.separatePage}
                  />
                )}
              </div>

              <div className="col-12 mb-3 col-sm-6 col-md-12 mb-3 col-lg-6 mb-3 col-xl-6 mb-3">
                <TransportOrderFilter controlWidth={'100%'} name="has_tasks" type="single" isBool />
              </div>

              <div className="col-12 mb-3 col-sm-6 col-md-12 mb-3 col-lg-6 mb-3 col-xl-6 mb-3">
                <TransportOrderFilter
                  controlWidth="100%"
                  name="individual"
                  type="single"
                  options={this.optionsIndividual}
                  noModify
                  separateFilter={this.props.separatePage}
                />
              </div>
            </div>

            <div className="row justify-content-start" style={{ width: '100%' }}>
              <div
                className={cn(
                  'col-12 mb-3 col-sm-12 col-md-12 mb-3 col-lg-8 mb-3 col-xl-6 mb-3',
                  this.props.overview && 'col-xl-12',
                )}
              >
                Datum ingepland{' '}
                <TransportOrderFilter
                  name="datePlanned"
                  type="ranged_date"
                  overview={this.props.overview}
                  separateFilter={this.props.separatePage}
                />
              </div>
            </div>
            <div className="row justify-content-start" style={{ width: '100%' }}>
              <div
                className={cn(
                  'col-12 mb-3 col-sm-12 col-md-12 mb-3 col-lg-8 mb-3 col-xl-6 mb-3',
                  this.props.overview && 'col-xl-12',
                )}
              >
                Datum beschikbaar{' '}
                <TransportOrderFilter
                  name="dateToPlan"
                  type="ranged_date"
                  overview={this.props.overview}
                  separateFilter={this.props.separatePage}
                />
              </div>
            </div>

            <div className="row p-0 mt-2 align-items-center">
              <div className="col">
                <FiltersCloud separateFilter={this.props.separatePage} />
              </div>
              <div className="col-auto">
                <ButtonComponent
                  style={'ButtonSoftEdit'}
                  onClick={() => this.props.applyFilters({ separateList: this.props.separatePage ?? null })}
                >
                  {this.lblStr('transport_order.filter.apply')}
                </ButtonComponent>
              </div>
            </div>
          </div>
                </div>
      </Container>
    );
  }
}

TransportOrderSearchComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    countries: selectCountries(),
    filter: selectTransportOrderFilter(),
    locale: makeSelectLocale(),
    workTransporters: selectWorks([REQUEST_TRANSPORTERS]),
    transporters: selectTransporters(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetchTransporters(callback) {
      dispatch(fetchTransporters(callback, 99999));
    },
    reset() {
      dispatch(resetTransportOrderFilter());
    },
    applyFilters(options) {
      if (options?.separateList) {
        dispatch(applyTransportOrderSeparateListFilters());
        return;
      }
      dispatch(applyTransportOrderFilters());
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const TransportOrderSearch = compose(withConnect, withRouter, injectIntl)(TransportOrderSearchComp);
